import React from "react";
import {  Button, Box, Container, Typography } from "@mui/material";
import { useNavigate} from 'react-router-dom';
const RegistrationComplete = () => {
    const navigate = useNavigate();
    return (
        <Container
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                marginTop:"-230px"
            }}
        >
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: 300,
                padding: 3,
                boxShadow: 3,
                textAlign: "center",
            }}>
                <Typography variant="h5" sx={{textAlign: "center", mb: 2}}>Регистрация</Typography>
                <Typography variant="string" color='success' sx={{textAlign: "center", mb: 2}}>Регистрация пользователя прошла успешно теперь можно войти</Typography>
                        <Button
                            onClick={()=>{navigate("/LoginForm")}}
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Войти
                        </Button>
            </Box>
        </Container>
    );
};

export default RegistrationComplete;
